export const ERequestState = {
	Init: "init",
	IsLoading: "isLoading",
	WithResult:'withResult',
	EmptyResponse:'mptyResponse'
};
